import { React, useState, useEffect, useContext } from 'react'
import Loading from "react-fullscreen-loading";
import HeaderSection from "../banner/HeaderSection";
import * as  CONST from "../../../component/config/Constant"
import "../../../assets/css/form.css";
import Swal from 'sweetalert2';
import axios from 'axios';
import { AuthContext } from '../../../component/context/AuthContext';
import { toast } from "react-toastify";
import viewImg from "../../../assets/img/icon/index.png";
import { Modal, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function Document() {
	
	const [authUserData, setAuthUserData] = useContext(AuthContext);
	const [loading, setLoading] = useState(false);
	const [formVal, setFormVal] = useState([{ document_name: '', documents: '' }]);
	const [userDocDetails, setUserDocDetails] = useState([{ doc_name: '', doc_file: '' }]);

	/** For Modalpopup */
	const [show, setShow] = useState(false);
	const [imagePreview, setImagePreview] = useState();
	const [docName, setDocName] = useState('');
	const [aadharDoc, setAadharDoc] = useState('');
	const [pancardDoc, setPancardDoc] = useState('');
	const [licenseDoc, setLicenseDoc] = useState('');
	const [experienceLetter, setExperienceLetter] = useState('');

	const [viewAadhar, setViewAadhar] = useState(0);
	const [viewPan, setViewPan] = useState(0);
	const [viewLicense, setViewLicense] = useState(0);
	const [viewExperienceLetter, setViewExperienceLetter] = useState(0);

	const [aadharLink, setAadharLink] = useState('');
	const [panLink, setPanLink] = useState('');
	const [licenseLink, setLicenseLink] = useState('');
	const [experienceLetterLink, setExperienceLetterLink] = useState('');

	const [appointmentLetter, setAppointmentLetter] = useState('');
	const [offerLetter, setOfferLetter] = useState('');

	const [viewAppointment, setViewAppointment] = useState(0);
	const [viewOffer, setViewOffer] = useState(0);

	const [appointmentLink, setAppointmentLink] = useState('');
	const [offerLink, setOfferLink] = useState('');

	const [validate, setValidate] = useState({});
	


	let isToken = '';
	let userId = '';
	if (authUserData) {
		if (authUserData[0]) {
			isToken = authUserData[0].token ? authUserData[0].token : "";
			userId = authUserData[0].user_id ? authUserData[0].user_id : 0;
		}
	}

	useEffect(() => {
		fetchDocumentData();
	}, []);



	// function viewDocImage(i, docName, docPath) {
	// 	setShow(true);
	// 	setDocName(docName)
	// 	setImagePreview(docPath);
	// }

	const handleClose = () => {
		setShow(false);
	}

	function handleShow(name, path) {
		setDocName(name);
		setImagePreview(path);
		setShow(true);
	}

	// function deleteHandler(i, id) {
	// 	Swal.fire({
	// 		title: 'Are you sure?',
	// 		text: "Do you want to delete this details?",
	// 		icon: 'warning',
	// 		showCancelButton: true,
	// 		confirmButtonColor: '#3085d6',
	// 		cancelButtonColor: '#d33',
	// 		confirmButtonText: 'Yes, delete it!'
	// 	}).then((result) => {
	// 		if (result.isConfirmed) {
	// 			setLoading(true);
	// 			const newFormData = [...userDocDetails];
	// 			if (id > 0) {
	// 				setLoading(true);
	// 				axios
	// 					.delete(CONST.DELETE_DOCUMENTS_DETAILS, {
	// 						headers: {
	// 							'Authorization': `Bearer ${isToken}`
	// 						},
	// 						data: {
	// 							doc_id: id
	// 						}
	// 					})
	// 					.then((response) => {

	// 						if (response) {
	// 							if (response.data.status == 'error') {
	// 								toast.error(response.data.message);
	// 							} else {
	// 								toast.success(response.data.message);
	// 								newFormData.splice(i, 1);
	// 								setUserDocDetails(newFormData);
	// 								//handleClose();
	// 								//fetchDocumentData()                                }
	// 							}
	// 						}
	// 					})
	// 					.catch((error) => {
	// 						setLoading(false);
	// 						console.log(error);
	// 						toast.error("Something went wrong. Please try again." + error);
	// 					});
	// 				setLoading(false);
	// 			}
	// 		}
	// 	})
	// }

	//fetch all documents details
	async function fetchDocumentData() {
		setLoading(true);
		await axios
			.get(CONST.GET_DOCUMENTS_DETAILS, {
				headers: {
					'Authorization': `Bearer ${isToken}`
				}
			})

			.then((response) => {
				const status = response.data.status;
				if (status === 'success') {
					const responseData = response.data.data;
					//var documentsInfo = [];
					//let isArray = Array.isArray(responseData);

					setUserDocDetails(responseData);
					console.log(responseData);
					//alert('Doc::' + JSON.stringify(responseData[0]));
					Object.keys(responseData).forEach(key => {
						const doc = responseData[key];
						switch (doc.document_name) {
							case 'Aadhar Card':
							setViewAadhar(1); 
							setAadharLink(doc.document_path);
							break;
							case 'Pan Card':
							setViewPan(1); 
							setPanLink(doc.document_path);
							break;
							case 'Driving License':
							setViewLicense(1); 
							setLicenseLink(doc.document_path);
							break;
							case 'Experience Letter':
							setViewExperienceLetter(1); 
							setExperienceLetterLink(doc.document_path);
							break;
							case 'Appointment Letter':
							setViewAppointment(1); 
							setAppointmentLink(doc.document_path);
							break;
							case 'Offer Letter':
							setViewOffer(1); 
							setOfferLink(doc.document_path);
							break;
						}
						});


					//setAadharDoc((responseData.document_name == 'Aadhar Card') ? )
				}
				else {
					toast.error(response.data.message);
				}
			})
			.catch((error) => {
				console.log(error);
			});
		setLoading(false);
	}

	const checkValidDoc = (doc_name) => {
		let validator = {};
		let isValid = true;

		if (doc_name === 'aadhar_card' && !aadharDoc) {
			validator.aadhar_card = 'Aadhar card is required'; isValid = false;
		} else if (doc_name === 'pan_card' && !pancardDoc) {
			validator.pan_card = 'Pan card is required'; isValid = false;
		} else if (doc_name === 'experience_letter' && !experienceLetter) {
			validator.experience_letter = 'Experience Letter is required'; isValid = false;
		} else if (doc_name === 'appointment_letter' && !appointmentLetter) {
			validator.appointment_letter = 'Appointment Letter is required'; isValid = false;
		} else if (doc_name === 'offer_letter' && !offerLetter) {
			validator.offer_letter = 'Offer Letter is required'; isValid = false;
		} else if (doc_name === 'driving_license' && !licenseDoc) {
			validator.driving_license = 'Driving License is required'; isValid = false;
		}
		if(!isValid) setValidate({ validate: validator });
		return isValid;
	};

	const handleUpload = async (doc) => {
		const isValid = checkValidDoc(doc);
		if (!isValid) return;
		let params = { user_id: userId };
		switch (doc) {
			case 'aadhar_card':
			params.document_name = 'Aadhar Card'; params.document = aadharDoc;
			break;
			case 'pan_card':
			params.document_name = 'Pan Card'; params.document = pancardDoc;
			break;
			case 'experience_letter':
			params.document_name = 'Experience Letter'; params.document = experienceLetter;
			break;
			case 'appointment_letter':
			params.document_name = 'Appointment Letter'; params.document = appointmentLetter;
			break;
			case 'offer_letter':
			params.document_name = 'Offer Letter'; params.document = offerLetter;
			break;
			case 'driving_license':
			params.document_name = 'Driving License'; params.document = licenseDoc;
			break;
		}

		setLoading(true);
		await axios.post(CONST.ADD_DOCUMENTS_DETAILS, params, {
			headers: {
			'Authorization': `Bearer ${isToken}`,
			'Content-Type': 'multipart/form-data',
			}
		})
		.then((response) => {
			setLoading(false);
			if (response.data.status === 'success') {
			toast.success(response.data.message);
			fetchDocumentData(); // refresh view after upload
			} else {
			toast.error(response.data.message);
			}
		})
		.catch((error) => {
			setLoading(false);
			toast.error("Something went wrong. Please try again.");
			console.error(error);
		});
	};

return (
		<>
			<Loading
				loading={loading}
				background="rgba(0, 0, 0, 0.5)"
				loaderColor="#fff"
			/>
			<HeaderSection
				title=""
				heading="Document Information"
				addButton=''
				addLink="#"
				addLinkName="Add More"
				linktype="add" />

			<div className="page-body">
				<div className="container-xl">
					<div className="row row-cards">
						<div className="col-12">
							<div className="card">
								<table className="table table-hover table-outline table-vcenter text-nowrap card-table">
									<thead>
										<tr>
											<th>Name</th>
											<th>Document</th>
											<th>Upload</th>
											<th>Action</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>Aadhar Card</td>
											<td>
												<input
													type="file"
													name="aadhar_card"
													accept="application/msword, application/pdf"
													onChange={(e) => setAadharDoc(e.target.files[0])}
												/>
											</td>
											<td>
												<button
													type="button"
													className="mr-3 btn btn-primary"
													onClick={() => handleUpload('aadhar_card')}
												>
													Upload
												</button>
											</td>
											<td>
												{
													(viewAadhar == 1)
														?
														<>
															<Link onClick={() => handleShow("Aadhar Card", aadharLink)}>
																<img src={viewImg} alt='preview' width={32} className='cursor' />
															</Link>
															{/* <Link onClick={() => handleShow("Aadhar Card", aadharLink)}>
																<img src={deleteImg} alt='deleteImg' width={32} className='cursor' />
															</Link> */}
														</>
														:
														'-'
												}
											</td>
										</tr>
										<tr>
											<td>	Pan Card	</td>
											<td>
												<input
													type="file"
													name="pan_card"
													accept="application/msword, application/pdf"
													onChange={(e) => setPancardDoc(e.target.files[0])}
												/>
											</td>
											<td>
												<button
													type="button"
													className="mr-3 btn btn-primary"
													onClick={() => handleUpload('pan_card')}
												>
													Upload
												</button>
											</td>
											<td>
												{
													(viewPan == 1)
														?
														<>

															<Link onClick={() => handleShow("Pan Card", panLink)}>
																<img src={viewImg} alt='preview' width={32} className='cursor' />
															</Link>

															{/* <Link onClick={() => handleShow("Pan Card", aadharLink)}>
																<img src={deleteImg} alt='deleteImg' width={32} className='cursor' />
															</Link> */}

														</>
														:
														'-'
												}
											</td>
										</tr>
										<tr>
											<td>Experience Letter</td>
											<td>
												<input
													type="file"
													name="experience_letter"
													accept="application/msword, application/pdf"
													onChange={(e) => setExperienceLetter(e.target.files[0])}
												/>
											</td>
											<td>
												<button
													type="button"
													onClick={() => handleUpload('experience_letter')}
													className="mr-3 btn btn-primary"
												>
													Upload
												</button>
											</td>
											<td>
												{
													viewLicense
														?
														<>
															{viewExperienceLetter ? (
																<Link onClick={() => handleShow("Experience Letter", experienceLetterLink)}>
																	<img src={viewImg} alt='preview' width={32} className='cursor' />
																</Link>
																) : '-'}
															{/* <Link onClick={() => handleShow("Aadhar Card", aadharLink)}>
																<img src={deleteImg} alt='deleteImg' width={32} className='cursor' />
															</Link> */}

														</>
														:
														'-'
												}
											</td>
										</tr>
										<tr>
											<td>Appointment Letter</td>
											<td>
												<input
												type="file"
												accept="application/msword, application/pdf"
												onChange={(e) => setAppointmentLetter(e.target.files[0])}
												/>
											</td>
											<td>
												<button
												type="button"
												onClick={() => handleUpload('appointment_letter')}
												className="mr-3 btn btn-primary"
												>
												Upload
												</button>
											</td>
											<td>
												{viewAppointment ? (
												<Link onClick={() => handleShow("Appointment Letter", appointmentLink)}>
													<img src={viewImg} alt='preview' width={32} className='cursor' />
												</Link>
												) : '-'}
											</td>
											</tr>

										<tr>
										<td>Offer Letter</td>
										<td>
											<input
											type="file"
											name="offer_letter"
											accept="application/msword, application/pdf"
											onChange={(e) => setOfferLetter(e.target.files[0])}
											/>
										</td>
										<td>
											<button
											type="button"
											onClick={() => handleUpload('offer_letter')}
											className="mr-3 btn btn-primary"
											>
											Upload
											</button>
										</td>
										<td>
											{viewOffer ? (
											<Link onClick={() => handleShow("Offer Letter", offerLink)}>
												<img src={viewImg} alt='preview' width={32} className='cursor' />
											</Link>
											) : '-'}
										</td>
										</tr>
										<tr >
											<td>Driving license</td>
											<td>
												<input
													type="file"
													name="driving_license"
													accept="application/msword, application/pdf"
													onChange={(e) => setLicenseDoc(e.target.files[0])}
												/>
											</td>
											<td>
												<button
													type="button"
													onClick={() => handleUpload('driving_license')}
													className="mr-3 btn btn-primary"
												>
													Upload
												</button>
											</td>
											<td>
												{
													viewLicense
														?
														<>
															<Link onClick={() => handleShow("Driving License", licenseLink)}>
																<img src={viewImg} alt='preview' width={32} className='cursor' />
															</Link>

															{/* <Link onClick={() => handleShow("Aadhar Card", aadharLink)}>
																<img src={deleteImg} alt='deleteImg' width={32} className='cursor' />
															</Link> */}

														</>
														:
														''
												}
											</td>

										</tr>
									</tbody>
								</table>
							</div>
						</div >
					</div >
				</div >
			</div >

			<Modal show={show} onHide={handleClose} fullscreen={true}>

				<Modal.Header closeButton>
					<Modal.Title>Uploaded Dcoument - {docName}</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<div className="page-body">
						<iframe style={{ display: "block", width: "100vw", height: "100vh", border: "none" }} src={CONST.HOST + imagePreview} ></iframe>
					</div>
				</Modal.Body>

				<Modal.Footer>
				</Modal.Footer>

			</Modal>
		</>
	)
}

export default Document